import React, { forwardRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import * as Yup from "yup";

import { TextField } from "@mui/material";
import { ButtonsWrapper, StyledForm } from "./styled";

import { getRequiredField } from "helpers/formValidations";
import { MODELS_CONFIG, MODELS_PHRASE } from "./config";

import RegularButton from "components/CustomButtons/Button";
import { fetchNewBrandModel, fetchEditBrandModel } from "redux/actions/buildings/brands/brandsMetersActions";

const ModelsSchema = Yup.object({
  [MODELS_CONFIG.brand.key]: Yup.string().required(
    getRequiredField(MODELS_CONFIG.brand.label)
  ),
  [MODELS_CONFIG.model.key]: Yup.string().required(
    getRequiredField(MODELS_CONFIG.model.label)
  ),
});

export const ModelsForm = forwardRef((props) => {
  const dispatch = useDispatch();
  const { handleClose } = props;
  const { isAddMode, deleteMode, editModel } = useSelector((state) => state.brandsMeters);

  const handleCloseForm = () => {
    handleClose();
    reset();
  };

  const {
    reset,
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(ModelsSchema),
  });

  const onSubmit = React.useCallback(
    (formData) => {
      // You can use the validated data to make your API request here
      const body = {
        brand: formData[MODELS_CONFIG.brand.key],
        model: formData[MODELS_CONFIG.model.key]
      };

      if (isAddMode) {
        dispatch(fetchNewBrandModel(body));
      } else {
        dispatch(fetchEditBrandModel(editModel.id, body));
      }

      handleCloseForm();
    },
    [reset, isAddMode, editModel]
  );

  useEffect(() => {
    if (editModel) {
      setValue(MODELS_CONFIG.brand.key, editModel.brand);
      setValue(MODELS_CONFIG.model.key, editModel.name);
    }
  }, [editModel]);

  useEffect(() => {
    if (isAddMode) {
      reset();
    }
  }, [isAddMode]);


  return (
    <>
      <StyledForm component="form" fullWidth onSubmit={handleSubmit(onSubmit)}>
        <TextField
          fullWidth
          type="text"
          label={MODELS_CONFIG.brand.label}
          variant="outlined"
          error={!!errors[MODELS_CONFIG.brand.key]}
          helperText={errors[MODELS_CONFIG.brand.key]?.message}
          {...register(MODELS_CONFIG.brand.key)}
          size="small"
        />
        <TextField
          fullWidth
          type="text"
          label={MODELS_CONFIG.model.label}
          variant="outlined"
          error={!!errors[MODELS_CONFIG.model.key]}
          helperText={errors[MODELS_CONFIG.model.key]?.message}
          {...register(MODELS_CONFIG.model.key)}
          size="small"
        />

        <ButtonsWrapper>
          <RegularButton
            variant="contained"
            color="danger"
            onClick={handleClose}
          >
            {MODELS_PHRASE.modal.actions.cancel}
          </RegularButton>
          <RegularButton
            variant="contained"
            type="submit"
            color="info"
          >
            {isAddMode
              ? MODELS_PHRASE.modal.actions.add
              : deleteMode
              ? MODELS_PHRASE.modal.actions.delete
              : MODELS_PHRASE.modal.actions.save}
          </RegularButton>
        </ButtonsWrapper>
      </StyledForm>
    </>
  );
});
